// extracted by mini-css-extract-plugin
export default {"tabs":"styles_tabs__cTmdq","tab":"styles_tab__O9Cc4"};